var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "flex-row br ai-center amount-masked-input",
      class: { "lightgrey-bkg": _vm.disabled, "b-1": !_vm.disabled }
    },
    [
      _c("el-input", {
        staticClass: "b-0",
        attrs: {
          type: "text",
          placeholder: _vm.placeholder,
          disabled: _vm.disabled
        },
        on: {
          blur: function($event) {
            _vm.isFocus = false
          },
          focus: function($event) {
            _vm.isFocus = true
          }
        },
        model: {
          value: _vm.currentValue,
          callback: function($$v) {
            _vm.currentValue = $$v
          },
          expression: "currentValue"
        }
      }),
      _vm._v(" "),
      _c("span", {
        staticClass: "currency-symbol pr-2 nowrap",
        attrs: { "data-symbol": _vm.symbol }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }